<template>
  <v-sheet class="bg-red-darken-1 bg-texture" style="position: relative">
    <a
      :href="canonicalPaths.base"
      style="position: absolute; z-index: 1007; left: 0px; top: 0px"
      target="_blank"
    >
      <HyperdriveLogo collapse elevate />
    </a>

    <v-container>
      <v-row align="center" justify="center">
        <v-col class="text-center py-16">
          <p class="text-body-1 text-blue-darken-4 mt-8 mb-4">simply put...</p>
          <h1 class="text-body-1 mb-8">STUDENTS LIKE<br />US BETTER<br /></h1>

          <v-btn
            v-if="registerHref"
            :href="registerHref"
            class="text-capitalize font-weight-bold mb-5"
            elevation="4"
            rounded="pill"
            size="x-large"
            target="_blank"
            variant="outlined"
            >Register Now</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-card color="blue-darken-4" width="100%">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="auto">
            <ReviewStars :size="36" value="5" />
          </v-col>

          <v-col class="text-h5 text-center" cols="auto">
            {{ value.rating_text }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script setup>
import { usePageContext } from '#root/renderer/usePageContext'

defineProps({
  registerHref: {
    default: undefined,
    type: String
  },
  value: {
    required: true,
    type: Object
  }
})

const { canonicalPaths } = usePageContext()
</script>

<style scoped>
h1 {
  font-size: 90px !important;
  font-weight: 800;
  letter-spacing: -8px !important;
  line-height: 80px;
  word-spacing: 8px;
}

p {
  font-size: 45px !important;
  font-weight: 800;
  letter-spacing: -1px !important;
  line-height: 52px;
}

.bg-texture {
  /* Built using https://devsdash.com/tools/noise-texture-generator */
  /* Noise Density 70%, Size 1, Opacity 19%, Transparent, Background/Noise Color #FFFFFF, Width/Height 50 */
  background-image: url('data:image/png;base64,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');
}
</style>
